import { render, staticRenderFns } from "./TicketAlertsPage.vue?vue&type=template&id=93b327b0&"
import script from "./TicketAlertsPage.vue?vue&type=script&lang=js&"
export * from "./TicketAlertsPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketAlertsPage.vue?vue&type=style&index=0&id=93b327b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports